module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz5.6ed673f5.mp3";